import SnippetIcon from '@/components/atom/icon/search/SnippetIcon';

const DeliveryGuideSnippet = () => {
  return (
    <div className='border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]'>
      <div className={'px-[4px]'}>
        <div className={'flex flex-col gap-[8px]'}>
          <SnippetIcon />
          <span className={'typography-ui-24b whitespace-pre text-gray-900'}>
            앱으로 처방전 보내고,{'\n'}
            약국에서 <span className={'text-primary-700'}>방문 수령</span>하면 돼요!
          </span>
          <span className={'typography-ui-15r text-gray-400'}>아래에 해당하는 분만 약 배달 받을 수 있어요.</span>
          <div className={'typography-ui-13m flex flex-col gap-[8px] pt-[8px] text-gray-400'}>
            <p className={'flex items-center gap-[8px]'}>
              <span className={'w-[12px]'}>•</span>섬, 벽지 거주자
            </p>
            <p className={'flex items-center gap-[8px]'}>
              <span className={'w-[12px]'}>•</span>65세 이상 장기요양등급자
            </p>
            <p className={'flex items-center gap-[8px]'}>
              <span className={'w-[12px]'}>•</span>등록 장애인
            </p>
            <p className={'flex items-center gap-[8px]'}>
              <span className={'w-[12px]'}>•</span>희귀질환자 및 감염병 확진자 (1급, 2급)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryGuideSnippet;
